import store from '@/store/index';
import {
  getPrintersOfTenant,
  getLastConnect,
  saveConnectInfo
} from '@/api/printer';
export default {
  validatePrinter(device) {
    // 校验当前租户下是否包含该设备
    return new Promise(resolve => {
      getPrintersOfTenant()
      .then(res => {
        if (res && res.length) {
          const {
            address
          } = device

          resolve(!!res.find(i => i.bluetooth_address.toLowerCase() === address.toLowerCase()))
        } else {
          resolve(false)
        }
      })
    })
  },
  getLastConnectInfo(device) {
    // 校验上次连接的设备信息
    const {
      address
    } = device

    return getLastConnect({ bluetooth_address: address })
    .then(res => {
      if (res) {
        const {
          tenant_id,
          device_id,
          device_type,
          device_brand,
          device_model
        } = res

        if (tenant_id === 0) {
          this.$Toast.fail('当前打印机未激活')
          return ({
            code: 2
          })
        }

        const {
          deviceId,
          deviceType,
          deviceBrand,
          deviceModel
        } = store.state.appInfo

        if (
          device_id === deviceId
            ||
          device_type === deviceType
            &&
          device_brand === deviceBrand
            &&
          device_model === deviceModel
        ) {
          // 设备id相同或者类型、品牌、型号都相同，则判断为同一台设备
          return({
            code: 0
          })
        } else {
          return({
            code: 1,
            info: res
          })
        }
      } else {
        return ({
          code: 2
        })
      }
    })
  },
  saveDeviceConnectInfo(device) {
    // 保存连接时的终端信息
    const {
      address
    } = device
    const {
      deviceId,
      deviceType,
      deviceBrand,
      deviceModel,
      osName,
      osVersion,
      appWgtVersion
    } = store.state.appInfo
    const params = {
      bluetooth_address: address,
      device_id: deviceId,
      device_type: deviceType,
      device_brand: deviceBrand,
      device_model: deviceModel,
      system_name: osName,
      system_version: osVersion,
      app_version: appWgtVersion
    }
    console.log('saving', JSON.stringify(params))

    saveConnectInfo(params)
  },
}